/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { canistersGetApiV3Canisters } from "../../funcs/canistersGetApiV3Canisters.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3CanistersRequest$inboundSchema.optional(),
};

export const tool$canistersGetApiV3Canisters: ToolDefinition<typeof args> = {
  name: "canisters-get-api-v3-canisters",
  description: ``,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await canistersGetApiV3Canisters(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
